<template>
    <div class="vx-card px-6 py-2">
        <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label">Chi nhánh</label>
                <v-select v-model="selectedBranch" :options="branchOptions" name="branch" :clearable="false">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                <label class="vs-input--label">Khách hàng</label>
                <v-select class="w-full" v-model="selectedCustomer" :options="paginated"
                          :clearable="false" :filterable="false"
                          @open="onOpen"
                          @close="onClose"
                          @search="searchCustomer">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    <template #list-footer>
                        <li v-show="hasNextPage" ref="load" class="loader">
                            Loading more options...
                        </li>
                    </template>
                </v-select>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full md:mt-0 mt-2">
                <label class="vs-input--label">Thời gian</label>
                <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="openDateRange"
                                   @update="dateRangePicker" v-model="dateRange" class="w-full">
                </date-range-picker>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 w-1/2 md:mt-4 sm:mt-8 mt-4">
                <vs-button class="" color="primary" iconPack="feather" icon="icon-search"
                           @click="searchBooking">Tìm
                    kiếm
                </vs-button>
            </div>
        </div>

        <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                     class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="beautyBookingData" :animateRows="true" :pagination="true"
                     :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                     :onGridReady="onGridReady" :suppressPaginationPanel="true">
        </ag-grid-vue>

        <div class="vx-row" v-if="beautyBookingData.length > 0">
            <div class="vx-col md:w-1/2">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                    <span class="vx-col mt-2">Số phần tử / trang:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                            <span class="mr-2">
                                {{
                                    beautyBookingData.length - currentPage * pageSize > 0 ? currentPage *
                                        pageSize
                                        : beautyBookingData.length
                                }} /
                                {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import DateRangePicker from '../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import moment from "moment";
import Pagination from "../../../ui-elements/Pagination.vue";
// import CellRendererActionsWait from "./cell-renderer/CellRendererActionsWait";

export default {
    components: {
        vSelect,
        DateRangePicker,
        AgGridVue,
        Pagination,
        // CellRendererActionsWait
    },

    data() {
        return {
            branchOptions: [],
            selectedBranchValue: null,
            departmentOptions: [
                {value: null, label: 'Tất cả'}
            ],
            selectedDepartmentValue: null,
            doctorOptions: [
                {value: null, label: 'Tất cả'}
            ],
            selectedDoctorValue: null,
            customerOptions: [],
            selectedCustomerValue: null,
            dateRange: {
                startDate: new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0,0,0,0),
                endDate: new Date().setHours(23,59,59,999)
            },
            beautyBookingData: [],
            // maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                resizable: true,
            },
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: this.$t('menuCustomer.nanoCode'),
                    field: 'nanoCustomerCode',
                    width: 150,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Khách hàng',
                    field: 'customerName',
                    width: 200,
                    resizable: true
                },
                {
                    headerName: this.$t('menuCustomer.birthday'),
                    field: 'birthdayStr',
                    width: 150,
                    resizable: true
                },
                {
                    headerName: this.$t('menuCustomer.gender'),
                    field: 'genderStr',
                    width: 100,
                    resizable: true
                },
                {
                    headerName: 'Số điện thoại',
                    field: 'phoneNumber',
                    width: 150,
                    resizable: true
                },
                {
                    headerName: 'Nhóm dịch vụ',
                    field: 'serviceBooking',
                    width: 200,
                    resizable: true
                },
                {
                    headerName: 'Giờ đặt',
                    field: 'dateBooking',
                    width: 150,
                    resizable: true
                },
                // {
                //     headerName: 'Hành động',
                //     field: 'actions',
                //     width: 150,
                //     cellRendererFramework: 'CellRendererActionsWait',
                //     resizable: true,
                //     suppressSizeToFit: true
                // },
            ],
            pageNumber: 0,
            pageSize: 50,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            openDateRange: 'left',
            observer: null,
            limit: 20,
            search: '',
            typingSearchCustomer: null,
            textTypingSearch: null,
            pageNumberCustomer: 0,
            pageSizeCustomer: 50,
            showListCustomer: false,
        }
    },

    computed: {
        selectedBranch: {
            get() {
                return {
                    label: this.getLabelString(this.branchOptions.find(x => x.value == this.selectedBranchValue)),
                    value: this.branchOptions.find(x => x.value == this.selectedBranchValue)
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
                if (this.selectedBranchValue) {
                    this.getDepartmentData();
                    this.getDoctorData();
                    // this.getCustomerData();
                }
            }
        },
        selectedDepartment: {
            get() {
                return {
                    label: this.getLabelString(this.departmentOptions.find(x => x.value == this.selectedDepartmentValue)),
                    value: this.departmentOptions.find(x => x.value == this.selectedDepartmentValue)
                }
            },
            set(obj) {
                this.selectedDepartmentValue = obj ? obj.value : null;
                this.getDoctorData();
            }
        },
        selectedDoctor: {
            get() {
                return {
                    label: this.getLabelString(this.doctorOptions.find(x => x.value == this.selectedDoctorValue)),
                    value: this.doctorOptions.find(x => x.value == this.selectedDoctorValue)
                }
            },
            set(obj) {
                this.selectedDoctorValue = obj ? obj.value : null;
            }
        },
        selectedCustomer: {
            get() {
                return {
                    label: this.getLabelString(this.customerOptions.find(x => x.value == this.selectedCustomerValue)),
                    value: this.customerOptions.find(x => x.value == this.selectedCustomerValue)
                }
            },
            set(obj) {
                this.selectedCustomerValue = obj ? obj.value : null;
            }
        },

        filtered() {
            return this.customerOptions;
        },
        paginated() {
            return this.filtered.slice(0, this.limit);
        },
        hasNextPage() {
            return true;
        },
    },

    async created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.branchOptions.unshift({value: null, label: 'Tất cả'});

        if (this.$route.query.customerId) {
            this.selectedCustomerValue = parseInt(this.$route.query.customerId, 10)
        }

        // this.getDepartmentData();
        // this.getDoctorData();
        await this.getCustomerData();
        this.searchBooking();
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
            if (val >= 768) {
                this.openDateRange = 'left'
            } else {
                this.openDateRange = 'right'
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteBeautyBooking'(val) {
            if (val) {
                this.searchBooking();
                this.$store.commit('DELETE_BEAUTY_BOOKING', false);
            }
        }
    },

    methods: {

        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },

        getDepartmentData() {
            return new Promise((resolve, reject) => {
                let body = {
                    organizationBranchId: this.selectedBranchValue,
                }

                this.departmentOptions = [];

                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', body).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.departmentOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.departmentName
                            }
                        });
                    }
                    this.departmentOptions.unshift({value: null, label: 'Tất cả'});
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getDoctorData() {
            return new Promise((resolve, reject) => {
                let url = '/beauty-booking/get-list-doctor-department';
                if (this.selectedBranchValue) {
                    url += '?organizationBranchId=' + this.selectedBranchValue
                }
                this.doctorOptions = [];

                this.$vs.loading();
                this.$crm.get(url).then(res => {
                    if (res.data.data && res.data.data.length > 0) {
                        this.doctorOptions = res.data.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                    }
                    this.doctorOptions.unshift({value: null, label: 'Tất cả'})
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getCustomerData() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let url = '/loyalty/customer/find'
                if (this.textTypingSearch != this.search) {
                    this.textTypingSearch = this.search;
                    this.customerOptions = [
                        {value: null, label: 'Tất cả'}
                    ];
                }
                url += `?pageNumber=${this.pageNumberCustomer}&pageSize=${this.pageSizeCustomer}`;
                if (this.textTypingSearch) url += `&keySearch=${this.textTypingSearch}`;
                this.$crm.get(url).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        let customer = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.phoneNumber + ' - ' + el.fullName
                            }
                        });
                        this.customerOptions.push(...customer);
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59, 999));
        },

        searchBooking() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let payload = {
                customerId: this.selectedCustomerValue,
                organizationBranchId: this.selectedBranchValue ? this.selectedBranchValue : userInfo.organizationBranchId,
                endDate: new Date(this.dateRange.endDate).toISOString(),
                startDate: new Date(this.dateRange.startDate).toISOString(),
                status: 2,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
            }
            this.beautyBookingData = [];

            this.$vs.loading();
            this.$crm.post('/beauty-booking/find-by-condition', payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.beautyBookingData = res.data.content.map(el => {
                        el.stt = this.pageSize * this.pageNumber + res.data.content.indexOf(el) + 1;
                        let branch = this.branchOptions.find(x => x.value == el.organizationBranchId);
                        el.organizationBranchName = branch ? branch.label : null;
                        // el.doctorName = el.beautyBookingDetails[0].performer ? el.beautyBookingDetails[0].performer.fullName : null;
                        el.dateBooking = ((el.beautyBookingDetails[0].startTime ? el.beautyBookingDetails[0].startTime : '') + ' ' + moment(el.beautyBookingDetails[0].bookingDate).format('DD/MM/YYYY'));
                        el.serviceBooking = el.beautyBookingDetails[0].beautyServicePackage ? (el.beautyBookingDetails[0].beautyServicePackage.code + '.' + el.beautyBookingDetails[0].beautyServicePackage.name) : el.beautyBookingDetails[0].beautyPackageCombo ? (el.beautyBookingDetails[0].beautyPackageCombo.code + '.' +el.beautyBookingDetails[0].beautyPackageCombo.name) : null;
                        el.customerName = el.loyaltyCustomer.fullName;
                        el.nanoCustomerCode = el.loyaltyCustomer.nanoCustomerCode;
                        el.phoneNumber = el.loyaltyCustomer.phoneNumber ? this.convertPhone(el.loyaltyCustomer.phoneNumber) : null;
                        el.birthdayStr = el.loyaltyCustomer.birthday ? moment(el.loyaltyCustomer.birthday).format('DD/MM/YYYY') : el.loyaltyCustomer.birthDayRaw;
                        el.genderStr = el.loyaltyCustomer.gender === 0 ? this.$t('genderOption.unknown') : el.loyaltyCustomer.gender === 1 ? this.$t('genderOption.male') : el.loyaltyCustomer.gender === 2 ? this.$t('genderOption.female') : null;
                        return el;
                    })
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.searchBooking();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.searchBooking();
        },

        convertPhone(phone) {
            let arrPhone = phone.split('');
            arrPhone[4] = '*';
            arrPhone[5] = '*';
            arrPhone[6] = '*';
            return arrPhone.join().replaceAll(',', '');
        },

        async onOpen() {
            this.showListCustomer = true;
            if (this.hasNextPage) {
                await this.$nextTick()
                this.observer.observe(this.$refs.load)
            }
        },
        onClose() {
            this.search = '';
            this.pageNumberCustomer = -1;
            this.showListCustomer = false;
            this.observer.disconnect()
        },
        async infiniteScroll([{ isIntersecting, target }]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limit += 20;
                this.pageNumberCustomer += 1;
                await this.$nextTick();
                ul.scrollTop = scrollTop;
                this.getCustomerData();
            }
        },

        searchCustomer(query) {
            if (this.showListCustomer) {
                if (this.search != query) this.pageNumberCustomer = 0;
                this.search = query;
                clearTimeout(this.typingSearchCustomer);
                this.typingSearchCustomer = setTimeout(this.doneTypingSearch, 1500)
            }
        },

        async doneTypingSearch() {
            await this.getCustomerData();
            if (this.customerOptions.length === 1) this.selectedCustomerValue = null;
            await this.onOpen();
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
        this.observer = new IntersectionObserver(this.infiniteScroll);
    },
}
</script>

<style>
.vs--single .vs__selected {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
